<ng-container *ngIf="weapon">
  <div class="title-wrapper">
    <h4 class="title-text text-primary">{{  'Update Weapon' | translate }}</h4>
  </div>
  <!-- ============================================ -->


  <form [formGroup]="weaponForm">
    <div class="addTicket-creation bg-light">
      <div class="row mt-1 mb-2">
        <div class="col-md-6 col-12">
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="weaponForm.get('fullName')"
              type="text"
              requiredMessage="{{ 'Required Field' | translate }}"
              placeholder="{{ 'Full Name' | translate }}"
              label="{{ 'Full Name' | translate }}"
            ></app-evento-input>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-input
                [eventoFormControl]="weaponForm.get('nid')"
                type="text"
                requiredMessage="{{ 'Required Field' | translate }}"
                placeholder="{{ '0123456789' | translate }}"
                label="{{ 'NID' | translate }}"
              ></app-evento-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-select
                [eventoFormControl]="weaponForm.get('weaponType')"
                placeholder="{{ 'Weapon Type' | translate }}"
                [multiple]="false"
                [items]="weaponType"
                [hasStaticValues]="true"
                label="{{ 'Weapon Type' | translate }}"
              >
              </app-evento-select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-select
                [eventoFormControl]="weaponForm.get('licenseType')"
                placeholder="{{ 'Weapon License Type' | translate }}"
                [multiple]="false"
                [items]="licenseType"
                [hasStaticValues]="true"
                (changeEvent)="onChangeLicenseType($event)"
                label="{{ 'Weapon License Type' | translate }}"
              >
              </app-evento-select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-input
                [eventoFormControl]="weaponForm.get('brand')"
                type="text"
                requiredMessage="{{ 'Required Field' | translate }}"
                placeholder="{{ 'Weapon Brand' | translate }}"
                label="{{ 'Weapon Brand' | translate }}"
              ></app-evento-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-select
                [eventoFormControl]="weaponForm.get('caliber')"
                placeholder="{{ '9mm' | translate }}"
                [multiple]="false"
                [items]="caliber"
                [hasStaticValues]="true"
                label="{{ 'Weapon Caliber' | translate }}"
              >
              </app-evento-select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-input
                [eventoFormControl]="weaponForm.get('weaponNumber')"
                type="text"
                requiredMessage="{{ 'Required Field' | translate }}"
                placeholder="{{ '0123456789' | translate }}"
                label="{{ 'Weapon Number' | translate }}"
              ></app-evento-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <app-evento-input
              [eventoFormControl]="weaponForm.get('licenseExpiryAt')"
              type="datepicker"
              requiredMessage="{{ 'Required Field' | translate }}"
              label="{{ 'Weapon License Expiry At' | translate }}"
              placeholder="{{ 'Weapon License Expiry At' | translate }}"
            ></app-evento-input>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-group">
            <div class="form-group">
              <app-evento-input
                [eventoFormControl]="weaponForm.get('version')"
                type="text"
                requiredMessage="{{ 'Required Field' | translate }}"
                placeholder="{{ 'Version' | translate }}"
                label="{{ 'Version' | translate }}"
              ></app-evento-input>
            </div>
          </div>
        </div>
        <ng-container *ngIf="weaponForm.get('licenseType').value === 'HAVING'">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <app-evento-input
                [eventoFormControl]="weaponForm.get('permitsExpiryAt')"
                type="datepicker"
                requiredMessage="{{ 'Required Field' | translate }}"
                label="{{ 'Weapon Permits Expiry At' | translate }}"
                placeholder="{{ 'Weapon Permits Expiry At' | translate }}"
              ></app-evento-input>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <div class="form-group">
                <app-evento-input
                  [eventoFormControl]="weaponForm.get('permitsNumber')"
                  type="text"
                  requiredMessage="{{ 'Required Field' | translate }}"
                  placeholder="{{ 'Weapon Permits Number' | translate }}"
                  label="{{ 'Weapon Permits Number' | translate }}"
                ></app-evento-input>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row mt-1 mb-2">
        <div class="col-md-6 col-12">
          <button
            type="button"
            class="btn btn-primary title-action end"
            [disabled]="!weaponForm.valid"
            (click)="submit()"
          >
            <i class="far fa-save mr-3 align-middle"></i>
            {{ "Save" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-container>



